import React, { useState, useRef, useEffect } from "react";
import { Box } from "@mui/material";

const ImageWrapper = ({
  children,
  annotations = [],
  scale,
  selectedIsolationMarkup,
  PID_IMAGE_ID,
}) => {
  const containerRef = useRef(null);

  return (
    <Box
      ref={containerRef}
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
      }}
      onContextMenu={(e) => e.preventDefault()}>
      {children}

      {annotations.map((annotation, index) => {
        return (
          <Annotation
            key={annotation.id || index}
            containerRef={containerRef}
            annotation={annotation}
            scale={scale}
            selectedIsolationMarkup={selectedIsolationMarkup}
            PID_IMAGE_ID={PID_IMAGE_ID}
          />
        );
      })}
    </Box>
  );
};

export default ImageWrapper;

function Annotation({
  containerRef,
  annotation,
  scale,
  selectedIsolationMarkup,
  PID_IMAGE_ID,
}) {
  const isSelected = selectedIsolationMarkup?.number === annotation.number;
  const { x: xStr, y: yStr, markup_image_url } = annotation;
  const x = parseFloat(xStr);
  const y = parseFloat(yStr);

  // Convert absolute coordinates to percentage for display
  const imageElement = document.getElementById(PID_IMAGE_ID);
  if (!imageElement || !containerRef.current) return null;

  // Get the container dimensions (ImageWrapper)
  const containerRect = containerRef.current.getBoundingClientRect();
  const imageRect = imageElement.getBoundingClientRect();

  // Calculate the width and height difference ratios
  const widthRatio = containerRect.width / imageRect.width;
  const heightRatio = containerRect.height / imageRect.height;

  // Adjust X and Y coordinates to account for container size differences
  const xPercent = ((x / imageElement.naturalWidth) * 100) / widthRatio;
  const yPercent = ((y / imageElement.naturalHeight) * 100) / heightRatio;

  // Determine visual size based on zoom level
  let visualSize = 10;

  if (scale > 3) {
    visualSize = 8;
  }

  if (scale > 7) {
    visualSize = 6;
  }

  if (scale > 10) {
    visualSize = 4;
  }

  return (
    <Box
      sx={{
        position: "absolute",
        left: `${xPercent}%`,
        top: `${yPercent}%`,
        pointerEvents: "auto",
        width: `${visualSize}px`,
        height: `${visualSize}px`,
        zIndex: 10,
        transform: "translate(0%, -100%)",
      }}>
      <img
        src={markup_image_url}
        alt="markup"
        style={{
          width: `${visualSize}px`,
          height: `${visualSize}px`,
          display: "block",
          filter: "drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.3))",
          border: isSelected ? "1px solid black" : "none",
        }}
      />
    </Box>
  );
}
